import React, { FC } from "react";
import { Typography } from "@mui/material";
import { Image } from "cloudinary-react";
import ReusableAccordian from "../ReusableAccordion";
import Choices from "../Choices";
import {
  singlePocket, //single pocket option
  doublePocketOptions, //pocket left, right or double options
  pocketDouble, //this is for single pocket required (disabled btn) and double pocket option
} from "../../initialValues/screens";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import useScreenPocketSelector from "./useScreenPocketSelector";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";
import PleaseNote from "../PleaseNote";

interface ScreenPocketProps {
  isDoubleScreenSelected: boolean;
  oneSideOddConfig: boolean;
  defaultPocketWide: () => void;
  displayedPocketImg: string;
  isPocketAllowed: boolean;
}

const ScreenPocketAccordian: FC<ScreenPocketProps> = ({
  isDoubleScreenSelected,
  oneSideOddConfig,
  defaultPocketWide,
  displayedPocketImg,
  isPocketAllowed
}) => {
  const {
    filteredPocketImg,
    handleClick,
    material,
    screenPocketVal,
    isCornerUnit,
    screenPocket,
  } = useScreenPocketSelector(defaultPocketWide, displayedPocketImg);
  const { readOnly } = useIsReadOnlyContextProviderContext();

  return (
    <ReusableAccordian
      accordionName="screenPocket"
      heading="Screen Pocket"
      secondaryHeading="Add a screen pocket?"
      colOrRow="col"
    >
      <ColLayout style={{ marginLeft: 40 }}>

        <PleaseNote
          notes={[
            "*Up-charge applies for each pocket added",
            isDoubleScreenSelected &&
              oneSideOddConfig &&
              "Must have a screen pocket on daily door side to avoid blocking handle hardware",
          ]}
        />

        <RowLayout>
          {oneSideOddConfig &&
            isDoubleScreenSelected &&
            !isCornerUnit &&
            pocketDouble.map((state) => (
              <div
                key={state.id}
                onClick={() =>
                  readOnly
                    ? null
                    : handleClick(
                        state.label,
                        "double",
                        state.disabled || false,
                      )
                }
              >
                <Choices
                  label={state.label}
                  variant={
                    state.label === "Add Pocket" ||
                    state.label === screenPocketVal
                      ? "filled"
                      : "outlined"
                  }
                  checkMark={
                    state.label === "Add Pocket" ||
                    state.label === screenPocketVal
                  }
                  disabled={state.disabled || readOnly}
                  wide={true}
                />
              </div>
            ))}
          {!isDoubleScreenSelected &&
            singlePocket.map((state) => (
              <div
                key={state.id}
                onClick={() =>
                  readOnly
                    ? null
                    : handleClick(
                        state.label,
                        "single",
                        state.disabled || false,
                      )
                }
              >
                <Choices
                  label={state.label}
                  variant={state.label === screenPocket ? "filled" : "outlined"}
                  checkMark={state.label === screenPocket}
                  disabled={state.disabled || readOnly}
                  wide={true}
                />
              </div>
            ))}
          {((isCornerUnit && isDoubleScreenSelected) ||
            (!isCornerUnit && isDoubleScreenSelected && !oneSideOddConfig)) &&
            doublePocketOptions.map((state) => (
              <div
                key={state.id}
                onClick={() =>
                  readOnly
                    ? null
                    : handleClick(
                        state.label,
                        "doubleNoDefault",
                        state.disabled || false,
                      )
                }
              >
                <Choices
                  label={state.label}
                  variant={
                    state.label === screenPocketVal ? "filled" : "outlined"
                  }
                  checkMark={state.label === screenPocketVal}
                  disabled={state.disabled || readOnly}
                  wide={true}
                />
              </div>
            ))}
        </RowLayout>
      </ColLayout>

      <RowLayout>
        {displayedPocketImg && filteredPocketImg?.label && (
          <RowLayout>
            <ColLayout style={{ marginRight: 20 }}>
              <Image
                cloudName="ag-millworks"
                secure="true"
                publicId={
                  material === "All Wood"
                    ? filteredPocketImg.imgWood
                    : filteredPocketImg.img
                }
              />
              <Typography variant="caption">*As viewed from above</Typography>
            </ColLayout>

            <ColLayout style={{ marginLeft: 20 }}>
              <img src={filteredPocketImg.img2} alt="pocket" />
              <Typography variant="caption">
                *As viewed from exterior
              </Typography>
            </ColLayout>
          </RowLayout>
        )}
      </RowLayout>
    </ReusableAccordian>
  );
};

export default ScreenPocketAccordian;
